import { Image } from "src/swsh-native";

const RecapImageContentImage = ({ imageUrl }: { imageUrl: string }) => {
	return (
		<Image
			pointerEvents="none"
			alt="Recap image"
			src={imageUrl}
			dim="auto"
			style={{ flex: 1, width: "80%" }}
			contentFit="contain"
		/>
	);
};
export default RecapImageContentImage;
